import { Link, useNavigate } from '@tanstack/react-router';
import { Button, Pill } from '@/shared/components';
import { I } from '@/shared/icons';
import type { PropertyGroupResponse } from '@/shared/api';
import { lifecycleSummary } from './objectOverview';

interface ObjectCardProps {
  group: PropertyGroupResponse;
  canManage: boolean;
}

export function ObjectCard({ group, canManage }: ObjectCardProps) {
  const navigate = useNavigate();
  const summary = lifecycleSummary(group);
  return (
    <article className="border-line bg-card shadow-card flex flex-col rounded-lg border p-5">
      <div className="flex items-start justify-between gap-3">
        <Link
          to="/property-groups/$id"
          params={{ id: group.id }}
          className="focus-visible:ring-sage text-ink rounded-sm text-lg font-medium hover:underline focus-visible:outline-none focus-visible:ring-2"
        >
          {group.name}
        </Link>
        {group.needsAddressReview && (
          <Pill variant="warning" size="sm">
            Prüfung nötig
          </Pill>
        )}
      </div>

      <p className="text-ink-soft mt-1 text-sm">{group.address.street}</p>
      <p className="text-ink-faint text-sm">
        {group.address.postalCode} {group.address.city}
      </p>

      <div className="mt-4 flex items-end justify-between gap-3">
        <div>
          <p className="text-ink text-sm font-medium">
            {group.visibleApartmentCount} Apartment{group.visibleApartmentCount === 1 ? '' : 's'}
          </p>
          {summary && <p className="text-ink-faint mt-0.5 text-xs">{summary}</p>}
        </div>
        {canManage && (
          <Button
            variant="ghost"
            size="sm"
            leftIcon={<I name="Edit" size={14} />}
            onClick={() => void navigate({ to: '/property-groups/$id', params: { id: group.id } })}
          >
            Bearbeiten
          </Button>
        )}
      </div>
    </article>
  );
}
